<template>
  <div :class="{ [`docs-menu-left overflow-scroll scrolling-touch`]: isMainArea, [`docs-menu-auto`]: !isMainArea }" class="full scrolling-touch">
    <div class="px-3 py-3" :class="{ 'px-5': isMainArea }">
      <div v-for="(page, pi) in pages" :key="pi" class="py-2 text-blue-400">
        <router-link :to="`/doc/${page.path}`" exact-active-class="underline" @click="$emit('close')">{{ page.label }}</router-link>
      </div>
    </div>
    <div class=" border-b border-blue-500 my-5">
    </div>
    <div class="px-3" :class="{ 'px-5': isMainArea }">
      <div v-for="(page, pi) in demos" :key="pi + 'eg'" class="py-2 text-blue-400">
        <a v-if="mode === 'mobile'" :href="`/examples/${page.path}`" exact-active-class="underline" @click="$emit('close')">{{ page.label }}</a>
        <router-link v-if="mode === 'desktop'" :to="`/examples/${page.path}`" exact-active-class="underline" @click="$emit('close')">{{ page.label }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { routes } from '../../../../router.js'
export default {
  props: {
    isMainArea: {
      default: true
    }
  },
  data () {
    return {
      mode: window.innerWidth >= 1440 ? 'desktop' : 'mobile',
      pages: routes.find(e => e.path === '/doc').children,
      demos: routes.find(e => e.path === '/examples').children
    }
  }
}
</script>

<style>
.docs-menu-left{
  width: 285px;
  border-right: gray solid 1px;
  height: 100%;
  overflow: scroll;
}

.docs-menu-auto{
  width: 100%;
}
</style>